import { render, staticRenderFns } from "./Recipients.vue?vue&type=template&id=4f688a02&scoped=true&lang=pug"
import script from "./Recipients.vue?vue&type=script&lang=js"
export * from "./Recipients.vue?vue&type=script&lang=js"
import style0 from "./Recipients.vue?vue&type=style&index=0&id=4f688a02&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f688a02",
  null
  
)

export default component.exports